import bridge from '../../bridge/bridge';
import { ContinueRequest } from './actions';

/**
 * Tells POS that continue button has been clicked.
 *
 * @throws {RequestError}
 */
async function continueClicked(): Promise<void> {
  await bridge.app.postMessage(new ContinueRequest());
}

const view = {
  continueClicked,
};

export { view };
